import React, {useState} from 'react';
import {Box, Menu, Typography} from '@mui/material';
import {StaticDateTimePicker} from '@mui/x-date-pickers';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

/**
 * Date/Time picker field component
 * Manages its own anchor state internally
 * @param {Object} props
 * @param {string} props.label - Field label
 * @param {string} props.value - Current ISO date string value
 * @param {Function} props.onChange - Handler for date change
 */
export default function DateTimeField({
                                          label,
                                          value,
                                          onChange
                                      }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDateChange = (newValue) => {
        onChange(newValue ? newValue.toISOString() : '');
    };

    const isEmpty = !value;

    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
            <Typography variant="body2" color="text.secondary" sx={{minWidth: '150px', flexShrink: 0}}>
                {label}:
            </Typography>
            <Typography
                variant="body1"
                onClick={handleOpen}
                sx={{
                    color: isEmpty ? 'primary.main' : 'text.primary',
                    cursor: 'pointer',
                    minWidth: 0,
                    lineHeight: 1.5,
                    flex: 1,
                }}
            >
                {value ? dayjs(value).format('YYYY-MM-DD HH:mm') : 'Select date and time'}
            </Typography>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <StaticDateTimePicker
                        displayStaticWrapperAs="desktop"
                        value={value ? dayjs(value) : null}
                        onChange={handleDateChange}
                        onAccept={handleClose}
                    />
                </LocalizationProvider>
            </Menu>
        </Box>
    );
}

